export function keyExtractorId(item: { id: string }) {
  return item.id;
}
